(function () {
  const currentSection = document.currentScript.parentElement;
  const initParallax = (section) => {
    const columns = section.querySelectorAll(".image-collage-column");
    const leftColumn = columns[0];
    const rightColumn = columns[columns.length - 1];
    if (!leftColumn || !rightColumn || columns.length < 2) return;
    const updateParallax = () => {
      if (window.innerWidth <= 576) {
        leftColumn.style.transform = "";
        rightColumn.style.transform = "";
        return;
      }
      const rect = section.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      if (rect.bottom < 0 || rect.top > windowHeight) return;
      const scrollProgress = Math.max(
        0,
        Math.min(1, (windowHeight - rect.top) / (windowHeight + rect.height))
      );
      const maxOffset = 150;
      const leftOffset = maxOffset * scrollProgress;
      const rightOffset = -maxOffset * scrollProgress;
      leftColumn.style.transform = `translateY(${leftOffset}px)`;
      rightColumn.style.transform = `translateY(${rightOffset}px)`;
    };
    updateParallax();
    let ticking = false;
    window.addEventListener("scroll", () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          updateParallax();
          ticking = false;
        });
        ticking = true;
      }
    });
    window.addEventListener("resize", updateParallax);
  };
  const initHeadingAnimation = (section) => {
    if (!section || !section?.classList.contains("image-collage-section")) {
      return;
    }
    const enableAnimation = section.querySelector(
      "[data-enable-header-animation]"
    );
    if (!enableAnimation) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const section = entry.target;
            section.classList.add("anim-active");
            observer.unobserve(section);
          }
        });
      },
      {
        threshold: 0,
        rootMargin: "0px 0px -25% 0px",
      }
    );
    observer.observe(section);
  };
  initParallax(currentSection);
  initHeadingAnimation(currentSection);
  document.addEventListener("shopify:section:load", (e) => {
    initParallax(e.target);
    initHeadingAnimation(e.target);
  });
  document.addEventListener("shopify:section:select", (e) => {
    initParallax(e.target);
    initHeadingAnimation(e.target);
  });
})();
